let Roster = {
    Mario: {
        name: "Mario",
        Strength:11,
        Speed:12,
        Shooting:14,
        Passing:10,
        Tech:16,
        img:"https://mario.wiki.gallery/images/thumb/7/7e/MSBL_Mario_artwork_3.png/106px-MSBL_Mario_artwork_3.png"
    },
    Luigi: {
        name: "Luigi",
        Strength:11,
        Speed:11,
        Shooting:10,
        Passing:14,
        Tech:17,
        img:"https://mario.wiki.gallery/images/thumb/f/f1/MSBL_Luigi_artwork.png/120px-MSBL_Luigi_artwork.png"
    },
    Bowser: {
        name: "Bowser",
        Strength:17,
        Speed:9,
        Shooting:17,
        Passing:11,
        Tech:9,
        img:"https://mario.wiki.gallery/images/thumb/3/30/MSBL_Bowser_artwork.png/120px-MSBL_Bowser_artwork.png"
    },
    Yoshi: {
        name: "Yoshi",
        Strength:10,
        Speed:10,
        Shooting:17,
        Passing:17,
        Tech:9,
        img:"https://mario.wiki.gallery/images/thumb/7/72/MSBL_Yoshi_artwork.png/120px-MSBL_Yoshi_artwork.png"
    },
    Dk: {
        name: "Donkey Kong",
        Strength:16,
        Speed:9,
        Shooting:13,
        Passing:16,
        Tech:9,
        img:"https://mario.wiki.gallery/images/thumb/4/48/MSBL_Donkey_Kong_artwork.png/120px-MSBL_Donkey_Kong_artwork.png"
    },
    Peach: {
        name: "Princess Peach",
        Strength:9,
        Speed:17,
        Shooting:9,
        Passing:13,
        Tech:15,
        img:"https://mario.wiki.gallery/images/thumb/d/d2/MSBL_Peach_Artwork.png/120px-MSBL_Peach_Artwork.png"
    },
    Toad: {
        name: "Toad",
        Strength:9,
        Speed:17,
        Shooting:11,
        Passing:15,
        Tech:11,
        img:"https://mario.wiki.gallery/images/thumb/5/5d/MSBL_Toad_Artwork.png/120px-MSBL_Toad_Artwork.png"
    },
    Wario: {
        name: "Wario",
        Strength:17,
        Speed:9,
        Shooting:15,
        Passing:13,
        Tech:9,
        img:"https://mario.wiki.gallery/images/thumb/1/12/MSBL_Wario_Artwork.png/120px-MSBL_Wario_Artwork.png"
    },
    Waluigi: {
        name: "Waluigi",
        Strength:15,
        Speed:16,
        Shooting:9,
        Passing:9,
        Tech:14,
        img:"https://mario.wiki.gallery/images/thumb/a/a9/MSBL_Waluigi_Artwork.png/120px-MSBL_Waluigi_Artwork.png"
    },
    Rosalina: {
        name: "Rosalina",
        Strength:14,
        Speed:9,
        Shooting:17,
        Passing:10,
        Tech:13,
        img:"https://mario.wiki.gallery/images/thumb/0/06/MSBL_Rosalina_Artwork.png/120px-MSBL_Rosalina_Artwork.png"
    },
    Daisy: {
        name: "Daisy",
        Strength:13,
        Speed:9,
        Shooting:10,
        Passing:13,
        Tech:18,
        img:"https://mario.wiki.gallery/images/thumb/b/be/MSBL_Daisy_Artwork.png/200px-MSBL_Daisy_Artwork.png"
    },
    ShyGuy: {
        name: "Shy Guy",
        Strength:13,
        Speed:12,
        Shooting:13,
        Passing:13,
        Tech:12,
        img:"https://mario.wiki.gallery/images/thumb/7/7d/MSBL_Shy_Guy_Artwork.png/200px-MSBL_Shy_Guy_Artwork.png"
    },
    BowserJr: {
        name: "Bowser Jr",
        Strength:13,
        Speed:13,
        Shooting:11,
        Passing:17,
        Tech:9,
        img:"https://mario.wiki.gallery/images/thumb/9/90/MSBL_Bowser_Jr_artwork.png/200px-MSBL_Bowser_Jr_artwork.png"
    },
    Birdo: {
        name: "Birdo",
        Strength:9,
        Speed:10,
        Shooting:18,
        Passing:9,
        Tech:17,
        img:"https://mario.wiki.gallery/images/thumb/f/f2/MSBL_Birdo_artwork.png/200px-MSBL_Birdo_artwork.png"
    },
    Boom: {
        name: "Boom Boom",
        Strength:9999,
        Speed:9999,
        Shooting:9999,
        Passing:9999,
        Tech:9999,
        img:"https://mario.wiki.gallery/images/thumb/0/09/MSBL_Boom_Boom_artwork.png/100px-MSBL_Boom_Boom_artwork.png"
    }
};

export default Roster;